import React from "react";
import { motion } from "framer-motion";

/** Holographic grid + rotating cube wireframes for futuristic decoration. */
export default function HoloGrid({ className = "" }) {
  return (
    <div aria-hidden className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
      {/* Animated horizon grid */}
      <div className="absolute inset-x-0 bottom-0 h-1/2" style={{
        background:
          "linear-gradient(to top, rgba(139,92,246,0.06), transparent 70%)," +
          "repeating-linear-gradient(90deg, rgba(139,92,246,0.18) 0 1px, transparent 1px 56px)," +
          "repeating-linear-gradient(0deg, rgba(99,102,241,0.18) 0 1px, transparent 1px 56px)",
        maskImage: "linear-gradient(to top, black 30%, transparent 90%)",
        WebkitMaskImage: "linear-gradient(to top, black 30%, transparent 90%)",
        transform: "perspective(700px) rotateX(60deg) translateY(20%)",
        transformOrigin: "center bottom",
      }} />

      {/* Rotating wire cubes */}
      <motion.div
        className="absolute top-1/3 left-[6%] w-24 h-24 opacity-40"
        animate={{ rotate: 360 }}
        transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
      >
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <g stroke="rgba(167,139,250,0.7)" fill="none" strokeWidth="1.2">
            <rect x="20" y="20" width="50" height="50" />
            <rect x="35" y="35" width="50" height="50" />
            <line x1="20" y1="20" x2="35" y2="35" />
            <line x1="70" y1="20" x2="85" y2="35" />
            <line x1="20" y1="70" x2="35" y2="85" />
            <line x1="70" y1="70" x2="85" y2="85" />
          </g>
        </svg>
      </motion.div>
      <motion.div
        className="absolute bottom-1/4 right-[8%] w-28 h-28 opacity-40"
        animate={{ rotate: -360 }}
        transition={{ duration: 38, repeat: Infinity, ease: "linear" }}
      >
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <g stroke="rgba(103,232,249,0.7)" fill="none" strokeWidth="1.2">
            <polygon points="50,10 90,30 90,70 50,90 10,70 10,30" />
            <polygon points="50,30 75,42 75,68 50,80 25,68 25,42" />
            <line x1="50" y1="10" x2="50" y2="30" />
            <line x1="90" y1="30" x2="75" y2="42" />
            <line x1="90" y1="70" x2="75" y2="68" />
            <line x1="50" y1="90" x2="50" y2="80" />
            <line x1="10" y1="70" x2="25" y2="68" />
            <line x1="10" y1="30" x2="25" y2="42" />
          </g>
        </svg>
      </motion.div>

      {/* Scanline sweep */}
      <motion.div
        className="absolute inset-x-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, rgba(167,139,250,0.7), transparent)" }}
        initial={{ top: "-2%" }}
        animate={{ top: ["-2%", "102%"] }}
        transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
}
